// import e from 'enigma.js'
import qix_global from '~/api/session.js'
import { logger } from '~/utils/logger'

export const state = () => ({
  session: {},
  user_session: {},
  list: [],
  searchList: [],
  filtersSector: [],
  filtersNetwork: [],
  filtersCityCouncilDistrict: [],
  filtersAdmissionType: [],
  filtersSchoolLevel: [],
  filtersCommunitySchools: [],
  maxSchoolYear: {},
  maxSchoolYear_StudentMetrics: {},
  maxSchoolYear_SPR: {},
  maxSchoolYear_AEPR: {},
  maxSchoolYear_DWS: {},
  maxSchoolYear_Oct1: {},
  maxSchoolYear_Climate: {},
  maxSchoolYear_CC: {},
  maxSchoolYear_USL: {},

  // School Groupings
  councilDistrictList: [],
  studyAreaList: [],
  sectorsList: [],
  networkList: [],

  // Filters
  sectorFilters: [],
  networkFilters: [],
  councilDistrictFilters: [],
  admissionTypeFilters: [],
  schoolLevelFilters: [],
  communitySchoolsFilter: []
})

export const mutations = {
  createSession(state, data) {
    state.session = data
  },
  saveSession(state, data) {
    state.user_session = data
  },
  closeSession(state, data) {
    state.user_session = data
  },
  addMaxSchoolYear(state, data) {
    state.maxSchoolYear = data
  },
  addMaxSchoolYear_StudentMetrics(state, data) {
    state.maxSchoolYear_StudentMetrics = data
  },
  addMaxSchoolYear_SPR(state, data) {
    state.maxSchoolYear_SPR = data
  },
  addMaxSchoolYear_AEPR(state, data) {
    state.maxSchoolYear_AEPR = data
  },
  addMaxSchoolYear_DWS(state, data) {
    state.maxSchoolYear_DWS = data
  },
  addMaxSchoolYear_Oct1(state, data) {
    state.maxSchoolYear_Oct1 = data
  },
  addMaxSchoolYear_Climate(state, data) {
    state.maxSchoolYear_Climate = data
  },
  addMaxSchoolYear_CC(state, data) {
    state.maxSchoolYear_CC = data
  },
  addMaxSchoolYear_USL(state, data) {
    state.maxSchoolYear_USL = data
  },
  add(state, data) {
    state.list.push(data)
  },
  replace(state, data) {
    state.list = data
  },
  empty(state) {
    state.list = []
  },
  setSearchList(state, data) {
    state.searchList = data
  },

  // School Groupings
  addCouncilList: (state, data) => {
    state.councilDistrictList = data
  },
  addStudyAreaList: (state, data) => {
    state.studyAreaList = data
  },
  addSectorsList: (state, data) => {
    state.sectorsList = data
  },
  addNetworkList: (state, data) => {
    state.networkList = data
  },

  // Filters list
  clearFilters(state) {
    state.filtersSector = []
    state.filtersNetwork = []
    state.filtersCityCouncilDistrict = []
    state.filtersAdmissionType = []
    state.filtersSchoolLevel = []
  },
  SET_SECTOR_FILTERS(state, data) {
    state.sectorFilters = data
  },
  SET_NETWORK_FILTERS(state, data) {
    state.networkFilters = data
  },
  SET_COUNCIL_DISTRICT_FILTERS(state, data) {
    state.councilDistrictFilters = data
  },
  SET_ADMISSION_TYPE_FILTERS(state, data) {
    state.admissionTypeFilters = data
  },
  SET_SCHOOL_LEVEL_FILTERS(state, data) {
    state.schoolLevelFilters = data
  },
  SET_COMMUNITY_SCHOOLS_FILTERS(state, data) {
    state.communitySchoolsFilters = data
  },

  // Filters Selected
  SET_SECTOR(state, val) {
    if (state.filtersSector.indexOf(val) == -1) {
      state.filtersSector.push(val)
    } else {
      state.filtersSector.splice(state.filtersSector.indexOf(val), 1)
    }
  },
  SET_NETWORK(state, val) {
    if (state.filtersNetwork.indexOf(val) == -1) {
      state.filtersNetwork.push(val)
    } else {
      state.filtersNetwork.splice(state.filtersNetwork.indexOf(val), 1)
    }
  },
  SET_COUNCIL_DISTRICT(state, val) {
    if (state.filtersCityCouncilDistrict.indexOf(val) == -1) {
      state.filtersCityCouncilDistrict.push(val)
    } else {
      state.filtersCityCouncilDistrict.splice(
        state.filtersCityCouncilDistrict.indexOf(val),
        1
      )
    }
  },
  SET_ADMISSION_TYPE(state, val) {
    if (state.filtersAdmissionType.indexOf(val) == -1) {
      state.filtersAdmissionType.push(val)
    } else {
      state.filtersAdmissionType.splice(
        state.filtersAdmissionType.indexOf(val),
        1
      )
    }
  },
  SET_SCHOOL_LEVEL(state, val) {
    if (state.filtersSchoolLevel.indexOf(val) == -1) {
      state.filtersSchoolLevel.push(val)
    } else {
      state.filtersSchoolLevel.splice(state.filtersSchoolLevel.indexOf(val), 1)
    }
  },
  SET_COMMUNITY_SCHOOLS(state, val) {
    if (state.filtersCommunitySchools.indexOf(val) == -1) {
      state.filtersCommunitySchools.push(val)
    } else {
      state.filtersCommunitySchools.splice(
        state.filtersCommunitySchools.indexOf(val),
        1
      )
    }
  }
}

export const getters = {
  getFiltersSelected: state => {
    return [
      ...new Set(
        state.filtersSector.map(res => ({ action: 'filterSector', value: res }))
      ),
      ...new Set(
        state.filtersNetwork.map(res => ({
          action: 'filterNetwork',
          value: res
        }))
      ),
      ...new Set(
        state.filtersCityCouncilDistrict.map(res => ({
          action: 'filterCouncilDistrict',
          value: res
        }))
      ),
      ...new Set(
        state.filtersAdmissionType.map(res => ({
          action: 'filterAdmissionType',
          value: res
        }))
      ),
      ...new Set(
        state.filtersSchoolLevel.map(res => ({
          action: 'filterSchoolLevel',
          value: res
        }))
      ),
      ...new Set(
        state.filtersCommunitySchools.map(res => ({
          action: 'filterCommunitySchools',
          value: res
        }))
      )
    ]
  },
  list: state => {
    return state.list
  },
  maxSchoolYear: state => {
    return state.maxSchoolYear
  },
  maxSY: state => {
    const val = state.maxSchoolYear.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_StudentMetrics: state => {
    return state.maxSchoolYear_StudentMetrics
  },
  maxSchoolYear_SPR: state => {
    return state.maxSchoolYear_SPR
  },
  maxSY_SPR: state => {
    const val = state.maxSchoolYear_SPR.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSY_StudentMetrics: state => {
    const val = state.maxSchoolYear_StudentMetrics.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_AEPR: state => {
    return state.maxSchoolYear_AEPR
  },
  maxSY_AEPR: state => {
    const val = state.maxSchoolYear_AEPR.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_DWS: state => {
    return state.maxSchoolYear_DWS
  },
  maxSY_DWS: state => {
    const val = state.maxSchoolYear_DWS.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_Oct1: state => {
    return state.maxSchoolYear_Oct1
  },
  maxSY_Oct1: state => {
    const val = state.maxSchoolYear_Oct1.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_Climate: state => {
    return state.maxSchoolYear_Climate
  },
  maxSY_Climate: state => {
    const val = state.maxSchoolYear_Climate.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_OSS: () => {
    return { value: '2019-2020' }
  },
  maxSY_OSS: () => {
    const val = '2019-2020'
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_USL: state => {
    return state.maxSchoolYear_USL
  },
  maxSY_USL: state => {
    const val = state.maxSchoolYear_USL.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  maxSchoolYear_CC: state => {
    return state.maxSchoolYear_CC
  },
  maxSY_CC: state => {
    const val = state.maxSchoolYear_CC.value
    if (val) {
      return `${val.substr(0, 4)}-${val.substr(-2)}`
    } else {
      return ''
    }
  },
  slugToId: state => slug => {
    return state.list.find(p => p.slug == slug).slugid
  },
  slugToIdNetwork: state => slug => {
    return state.list.find(p => p.networkslug == slug).networkslugid
  },
  slugToIdCouncilDistrict: state => slug => {
    return state.list.find(p => p.councilDistrictslug == slug)
      .councilDistrictslugid
  },
  slugToIdStudyArea: state => slug => {
    return state.list.find(p => p.studyAreaslug == slug).studyAreaslugid
  },
  slugToIdSector: state => slug => {
    return state.list.find(p => p.sectorslug == slug).sectorslugid
  },
  slugToName: state => slug => {
    return state.list.find(p => p.slug == slug).name
  },
  slugToNameNetwork: state => slug => {
    return state.list.find(p => p.networkslug == slug).network
  },
  slugToNameCouncilDistrict: state => slug => {
    return state.list.find(p => p.councilDistrictslug == slug).councilDistrict
  },
  slugToNameStudyArea: state => slug => {
    return state.list.find(p => p.studyAreaslug == slug).studyArea
  },
  slugToNameSector: state => slug => {
    return state.list.find(p => p.sectorslug == slug).sector
  },
  slugToDisplayName: state => slug => {
    return state.list.find(p => p.slug == slug).displayName
  },
  slugToOpenedYear: state => slug => {
    return state.list.find(p => p.slug == slug).yearOpened
  },
  slugToClosedYear: state => slug => {
    return state.list.find(p => p.slug == slug).yearClosed
  },
  slugToDisplayNameNetwork: state => slug => {
    var displayName = state.list.find(p => p.networkslug == slug).network
    if (displayName.substring(0, 7) !== 'Network') {
      displayName = displayName + ' Network'
    }
    return displayName
  },
  slugToDisplayNameCouncilDistrict: state => slug => {
    return (
      'City Council District ' +
      state.list.find(p => p.councilDistrictslug == slug).councilDistrict
    )
  },
  slugToDisplayNameStudyArea: state => slug => {
    return (
      'Study Area ' + state.list.find(p => p.studyAreaslug == slug).studyArea
    )
  },
  slugToDisplayNameSector: state => slug => {
    return state.list.find(p => p.sectorslug == slug).sector + ' Schools'
  },
  slugToType: () => slug => {
    if (slug.toLowerCase() === 'citywide') {
      return 'citywide'
    } else if (
      slug.toLowerCase() === 'charter' ||
      slug.toLowerCase() === 'district' ||
      slug.toLowerCase() === 'alternative'
    ) {
      return 'sector'
    } else if (slug.toLowerCase().match(/^(studyarea\d{1,2})$/)) {
      return 'studyArea'
    } else if (slug.toLowerCase().match(/^(councildistrict\d{1,2})$/)) {
      return 'councilDistrict'
    } else if (
      slug
        .toLowerCase()
        .match(
          /^(network\d{1,2}|innovation|acceleration|opportunity|charters)$/
        )
    ) {
      return 'network'
    } else {
      return 'school'
    }
  },
  slugToSchoolLevel: state => slug => {
    return state.list.find(p => p.slug == slug).schoolLevel
  },
  slugToSector: state => slug => {
    return state.list.find(p => p.slug == slug).sector
  },
  slugToCommunitySchools: state => slug => {
    return state.list.find(p => p.slug == slug).communitySchools
  },
  searchList: state => {
    return state.searchList
  },
  filtered(state, searchTerm) {
    return state.list.filter(m => m.name.indexOf(searchTerm))
  },

  // Filters
  getSectorFilters(state) {
    return state.sectorFilters
  },
  getNetworkFilters(state) {
    return state.networkFilters
  },
  getCouncilDistrictFilters(state) {
    return state.councilDistrictFilters
  },
  getAdmissionTypeFilters(state) {
    return state.admissionTypeFilters
  },
  getSchoolLevelFilters(state) {
    return state.schoolLevelFilters
  },
  getCommunitySchoolsFilters(state) {
    return state.communitySchoolsFilters
  },

  // School Grouping
  councilDistrictList: state => {
    return state.councilDistrictList
  },
  studyAreaList: state => {
    return state.studyAreaList
  },
  sectorsList: state => {
    return state.sectorsList
  },
  networkList: state => {
    return state.networkList
  }
}

// I take a value and try to return a value in which
// the numeric values have a standardized number of
// leading and trailing zeros. This *MAY* help makes
// an alphabetic sort seem more natural to the user's
// intent.
function normalizeMixedDataValue(value) {
  var padding = '000'

  // Loop over all numeric values in the string and
  // replace them with a value of a fixed-width for
  // both leading (integer) and trailing (decimal)
  // padded zeroes.
  value = value.replace(/(\d+)((\.\d+)+)?/g, function(
    $0,
    integer,
    decimal,
    $3
  ) {
    // If this numeric value has "multiple"
    // decimal portions, then the complexity
    // is too high for this simple approach -
    // just return the padded integer.
    if (decimal !== $3) {
      return padding.slice(integer.length) + integer + decimal
    }

    decimal = decimal || '.0'

    return (
      padding.slice(integer.length) +
      integer +
      decimal +
      padding.slice(decimal.length)
    )
  })
  return value
}

export const actions = {
  async getMaxSchoolYear_Any({ commit }, { field, commitFunction, engine }) {
    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: [field]
            },
            qNullSuppression: true
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    let overviewResults = []

    const overview = await engine.createSessionObject(overviewHyperCube)

    const layout = await overview.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      const overviewData = {
        value: values[m][0].qText,
        id: parseInt(values[m][0].qElemNumber, 0),
        sort: parseInt(values[m][0].qText.substr(0, 4), 0)
      }
      overviewResults.push(overviewData)
    }

    logger.debug(overviewResults)

    const maxSchoolYearId =
      overviewResults.length > 0
        ? overviewResults.reduce(
            (max, school) => (school.sort > max ? school.sort : max),
            overviewResults[0].sort
          )
        : null

    const maxSchoolYearData = overviewResults.filter(
      y => y.sort == maxSchoolYearId //TODO: Need to know how we determine which year is the maximum completed school year for stats
    )[0]
    commit(commitFunction, maxSchoolYearData)
  },

  // Each of these must await the underlying dispatch (not fire-and-forget):
  // nuxtServerInit awaits these directly and closes the engine session once
  // its dispatch chain resolves, so the real engine work has to actually be
  // done by the time this action's own promise resolves.
  async get_maxSchoolYear({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear',
      commitFunction: 'addMaxSchoolYear',
      engine: payload.engine
    })
  },

  async get_maxSchoolYear_StudentMetrics({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_StudentMetrics',
      commitFunction: 'addMaxSchoolYear_StudentMetrics',
      engine: payload.engine
    })
  },

  async get_maxSchoolYear_SPR({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_SPR',
      commitFunction: 'addMaxSchoolYear_SPR',
      engine: payload.engine
    })
  },
  async get_maxSchoolYear_AEPR({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_AEPR',
      // field: 'SchoolYear_AEPR_4Recent',
      commitFunction: 'addMaxSchoolYear_AEPR',
      engine: payload.engine
    })
  },
  async get_maxSchoolYear_DWS({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_DWS',
      commitFunction: 'addMaxSchoolYear_DWS',
      engine: payload.engine
    })
  },
  async get_maxSchoolYear_Oct1({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_Oct1',
      commitFunction: 'addMaxSchoolYear_Oct1',
      engine: payload.engine
    })
  },
  async get_maxSchoolYear_Climate({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_Climate',
      commitFunction: 'addMaxSchoolYear_Climate',
      engine: payload.engine
    })
  },
  async get_maxSchoolYear_CC({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_CC',
      commitFunction: 'addMaxSchoolYear_CC',
      engine: payload.engine
    })
  },
  async get_maxSchoolYear_USL({ dispatch }, payload) {
    await dispatch('getMaxSchoolYear_Any', {
      field: 'SchoolYear_USL',
      commitFunction: 'addMaxSchoolYear_USL',
      engine: payload.engine
    })
  },

  async get_schools({ commit, state, dispatch }, payload) {
    debugger
    logger.debug('get_schools payload', payload)
    const engine = payload.engine
    logger.debug('get_schools engine', engine)
    const schoolHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          // {
          //   qDef: {
          //     qFieldDefs: ['School Name for Display'],
          //     qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
          //   },
          //   qNullSuppression: true
          // },
          {
            qDef: {
              qFieldDefs: ['Current School Name for Display'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['Current School Name (Publication)'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['School URL Slug']
            },
            qNullSuppression: true
          },
          {
            qDef: {
              qFieldDefs: ['Current Sector']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current Network']
            }
          },
          {
            qDef: {
              qFieldDefs: ['CSPR Study Area'] //TODO: Find correct name
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current City Council District']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current Admission Type']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current School Level']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current ZipCode']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current GradeSpan']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current StreetAddress']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current City']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current State']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current GPS Location']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Current SchoolLeader']
            }
          },
          {
            qDef: {
              qFieldDefs: ['SchoolYear']
            }
          },
          {
            qDef: {
              qFieldDefs: ['IsCommunitySchool']
            }
          },
          {
            qDef: {
              qFieldDefs: ['Year_SchoolOpened']
            }
          },
          {
            qDef: {
              qFieldDefs: ['SchoolYear_SchoolClosed']
            }
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 22, qHeight: 454 }]
      }
    }

    const comparisonHypercube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['Current School Name for Display'],
              qSortCriterias: [{ qSortByLoadOrder: 0, qSortByAscii: 1 }]
            },
            qNullSuppression: true
          }
        ],
        qMeasures: [
          {
            qDef: {
              qLabel: 'Enrollment',
              qDef:
                '=Sum({<[School_Accountable_Flag]={1}, [Flag_Oct1_CY]={1}>} Enrolled_Oct1)'
            }
          },
          {
            qDef: {
              qLabel: 'SPR Overall CY',
              qDef:
                "=Num(Avg({<[SPR.MetricID]={'overall'}, [Flag_SPREE_CY]={1}>} [SPREE.Percent_Meeting]), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'High Attendance CY',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, [Flag_Climate_CY]={1}>} Attendance_90more), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'Positive Behavior CY',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, [Flag_Climate_OSS_CY]={1}>} OSS_Zero), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'Reading CY',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, [Flag_StudentMetrics_CY]={1}>} InstructionalReadingTier_AtTarget), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'PSSA ELA Test CY',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, Sector-={'Alternative'}, [Flag_StudentMetrics_CY]={1}>} PSSA_ELA_G3_ProfAdv), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: '4 Year Cohort Graduation CY',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, Sector-={'Alternative'}, [Flag_CC_CY]={1}>} Graduation_4Years), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'College Matriculation CY',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, Sector-={'Alternative'}, [Flag_CC_CY]={1}>} FFM_Matriculated), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'PSSA/Keystone ELA/Lit Performance Sum (CY)',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, Sector-={'Alternative'}, [Flag_StudentMetrics_CY]={1}>} PSSAKeystone_ELA_ProfAdv), '##0%')"
            }
          },
          {
            qDef: {
              qLabel: 'PSSA/Keystone Math/Alg1 Performance Sum (CY)',
              qDef:
                "=Num(Avg({<[School_Accountable_Flag]={1}, Sector-={'Alternative'}, [Flag_StudentMetrics_CY]={1}>} PSSAKeystone_Math_ProfAdv), '##0%')"
            }
          }
        ],
        qInitialDataFetch: [{ qWidth: 20, qHeight: 500 }]
      }
    }

    //I think here and below within this action is no longer necessary TG 6/10/20
    let searchResults = []

    const comparisonSchools = await engine.createSessionObject(
      comparisonHypercube
    )
    const comparisonlayout = await comparisonSchools.getLayout()
    const comparisonValues = comparisonlayout.qHyperCube.qDataPages[0].qMatrix

    let resList = []
    for (let m = 0; m < comparisonValues.length; m++) {
      const res = {
        schoolNameSPR: comparisonValues[m][0].qText,
        enrollment: comparisonValues[m][1].qText,
        sprOverall: comparisonValues[m][2].qText,
        highAttendance: comparisonValues[m][3].qText,
        PositiveBehavior: comparisonValues[m][4].qText,
        Reading: comparisonValues[m][5].qText,
        PSSAELATest: comparisonValues[m][6].qText,
        fourYearCohortGraduation: comparisonValues[m][7].qText,
        collegeMatriculation: comparisonValues[m][8].qText,
        pssaLit: comparisonValues[m][9].qText,
        pssaAlg1: comparisonValues[m][10].qText
      }
      resList.push(res)
    }

    const schools = await engine.createSessionObject(schoolHyperCube)

    logger.debug(state.maxSchoolYear)

    await schools.selectHyperCubeValues(
      '/qHyperCubeDef',
      16,
      [state.maxSchoolYear.id],
      false
    )

    const layout = await schools.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      let compare = {}
      compare = {
        ...resList.find(val => val.schoolNameSPR === values[m][0].qText)
      }

      const schoolData = {
        name: values[m][0].qText,
        displayName: values[m][1].qText,
        slug: values[m][2].qText,
        slugid: parseInt(values[m][2].qElemNumber, 0),
        sector: values[m][3].qText,
        sectorslug: values[m][3].qText.replace(/\s/g, '').toLowerCase(),
        sectorslugid: parseInt(values[m][3].qElemNumber, 0),
        network: values[m][4].qText,
        networkslug: values[m][4].qText.replace(/\s/g, '').toLowerCase(),
        networkslugid: parseInt(values[m][4].qElemNumber, 0),
        studyArea: values[m][5].qText,
        studyAreaslug:
          'studyarea' + values[m][5].qText.replace(/\s/g, '').toLowerCase(),
        studyAreaslugid: parseInt(values[m][5].qElemNumber, 0),
        councilDistrict: values[m][6].qText,
        councilDistrictslug:
          'councildistrict' +
          values[m][6].qText.replace(/\s/g, '').toLowerCase(),
        councilDistrictslugid: parseInt(values[m][6].qElemNumber, 0),
        admissionType: values[m][7].qText,
        schoolLevel: values[m][8].qText,
        zipCode: values[m][9].qText,
        gradesServed: values[m][10].qText,
        addressLine1: values[m][11].qText,
        addressLine2:
          values[m][12].qText +
          ', ' +
          values[m][13].qText +
          ' ' +
          values[m][14].qText,
        position: {
          lat: Number(values[m][14].qText.split(',')[0]),
          lng: Number(values[m][14].qText.split(',')[1])
        },
        principal: values[m][15].qText,
        year: values[m][16].qText,
        communitySchools: values[m][17].qText,
        yearOpened: values[m][18].qText,
        yearClosed: values[m][19].qText,
        enrollment: compare.enrollment,
        sprOverall_cy: compare.sprOverall,
        highAttendance_cy: compare.highAttendance,
        positiveBehavior_cy: compare.PositiveBehavior,
        reading_cy: compare.Reading,
        pssaElaTest_cy: compare.PSSAELATest,
        fourYearCohortGraduation: compare.fourYearCohortGraduation,
        collegeMatriculation: compare.collegeMatriculation,
        pssaLit: compare.pssaLit,
        pssaAlg1: compare.pssaAlg1
      }
      searchResults.push(schoolData)
    }

    // Filling up filters in school groupings
    const networks = [
      ...new Set(searchResults.map(res => res.network).filter(e => e !== '-'))
    ]
    const councilDistricts = [
      ...new Set(
        searchResults.map(res => res.councilDistrict).filter(e => e !== '-')
      )
    ]
    const studyAreas = [
      ...new Set(searchResults.map(res => res.studyArea).filter(e => e !== '-'))
    ]
    const sectors = [
      ...new Set(searchResults.map(res => res.sector).filter(e => e !== '-'))
    ]
    // const communitySchools = [
    //   ...new Set(
    //     searchResults.map(res => res.communitySchools).filter(e => e !== '-')
    //   )
    // ]

    dispatch('setNetworks', networks)
    dispatch('setCouncilDistrict', councilDistricts)
    dispatch('setStudyArea', studyAreas)
    dispatch('setSectors', sectors)

    const searchResultsFiltered = searchResults.filter(
      (item, index) =>
        searchResults.findIndex(p => p.name == item.name) === index
    )

    let results = []
    searchResults.map((item, index) => {
      if (searchResults.findIndex(p => p.name == item.name) !== index) {
        const itemIdx = searchResultsFiltered.findIndex(
          p => p.name == item.name
        )
        let obj = searchResultsFiltered[itemIdx]

        if (!obj.zipCode.includes(item.zipCode)) {
          obj.zipCode = obj.zipCode + ', ' + item.zipCode
          obj.zipCode = obj.zipCode
            .split(', ')
            .sort()
            .join(', ')

          results.push(obj)
        }
      } else {
        results.push(item)
      }
    })

    const resultsFiltered = results.filter(
      (item, index) => results.findIndex(p => p.name == item.name) === index
    )

    commit('replace', resultsFiltered)
    commit('setSearchList', resultsFiltered)

    // Adding filters
    const unfilteredSectors = resultsFiltered
      .map(a => a.sector)
      .filter(e => e !== '-')
    const sectorFilters = [...new Set(unfilteredSectors)].sort()
    commit('SET_SECTOR_FILTERS', sectorFilters)

    const unfilteredNetworks = resultsFiltered
      .map(a => a.network)
      .filter(e => e !== '-')
    const networkFilters = [...new Set(unfilteredNetworks)].sort(function(
      a,
      b
    ) {
      var aMixed = normalizeMixedDataValue(a)
      var bMixed = normalizeMixedDataValue(b)

      return aMixed < bMixed ? -1 : 1
    })
    commit('SET_NETWORK_FILTERS', networkFilters)

    const unfilteredCouncilDistrict = resultsFiltered
      .map(a => a.councilDistrict)
      .filter(e => e !== '-')
    const councilDistrictFilters = [...new Set(unfilteredCouncilDistrict)].sort(
      function(a, b) {
        var aMixed = normalizeMixedDataValue(a)
        var bMixed = normalizeMixedDataValue(b)

        return aMixed < bMixed ? -1 : 1
      }
    )
    commit('SET_COUNCIL_DISTRICT_FILTERS', councilDistrictFilters)

    const unfilteredAdmissionType = resultsFiltered
      .map(a => a.admissionType)
      .filter(e => e !== '-')
    const admissionTypeFilters = [...new Set(unfilteredAdmissionType)].sort()
    commit('SET_ADMISSION_TYPE_FILTERS', admissionTypeFilters)

    const unfilteredSchoolLevel = resultsFiltered
      .map(a => a.schoolLevel)
      .filter(e => e !== '-')
    const schoolLevelFilters = [...new Set(unfilteredSchoolLevel)].sort()
    commit('SET_SCHOOL_LEVEL_FILTERS', schoolLevelFilters)

    const unfilteredCommunitySchools = resultsFiltered
      .map(a => a.communitySchools)
      .filter(e => e !== '-')
    const communitySchoolsFilters = [
      ...new Set(unfilteredCommunitySchools)
    ].sort()
    commit('SET_COMMUNITY_SCHOOLS_FILTERS', communitySchoolsFilters)
  },

  async setNetworks({ commit }, data) {
    const networksSorted = data.sort(function(a, b) {
      var aMixed = normalizeMixedDataValue(a)
      var bMixed = normalizeMixedDataValue(b)

      return aMixed < bMixed ? -1 : 1
    })

    let networkList = []
    networksSorted.forEach(res => {
      let networkObj = {}
      if (res.toLowerCase().includes('network')) {
        networkObj.value = res.toLowerCase().replace(' ', '')
        networkObj.title = res
      } else {
        networkObj.value = res.toLowerCase()
        networkObj.title = res + ' Network'
      }

      networkList.push(networkObj)
    })

    commit('addNetworkList', networkList)
  },

  async setCouncilDistrict({ commit }, data) {
    const overviewResultsSorted = data.sort((a, b) =>
      parseFloat(a) > parseFloat(b) ? 1 : -1
    )

    let councilDistrictList = []
    overviewResultsSorted.forEach(res => {
      let councilDistrictObj = {}
      councilDistrictObj.value = 'councildistrict' + res
      councilDistrictObj.title = 'City Council District ' + res

      councilDistrictList.push(councilDistrictObj)
    })

    commit('addCouncilList', councilDistrictList)
  },

  async setStudyArea({ commit }, data) {
    const studyAreasSorted = data.sort(function(a, b) {
      var aMixed = normalizeMixedDataValue(a)
      var bMixed = normalizeMixedDataValue(b)

      return aMixed < bMixed ? -1 : 1
    })

    let studyAreaList = []
    studyAreasSorted.forEach(res => {
      let studyAreaObj = {}
      studyAreaObj.value = 'studyarea' + res
      studyAreaObj.title = 'Study Area ' + res

      studyAreaList.push(studyAreaObj)
    })

    commit('addStudyAreaList', studyAreaList)
  },

  async setSectors({ commit }, data) {
    const overviewResultsSorted = data.sort((a, b) => (a > b ? 1 : -1))

    let sectorsList = []
    overviewResultsSorted.forEach(res => {
      let sectorObj = {}
      if (res.value === 'Alternative') {
        sectorObj.value = 'alteds'
        sectorObj.title = 'Alt-Ed Schools'
      } else {
        sectorObj.value = res.toLowerCase()
        sectorObj.title = res + ' Schools'
      }

      sectorsList.push(sectorObj)
    })

    commit('addSectorsList', sectorsList)
  },

  // async setCommunitySchools({ commit }, data) {
  //   const communitySchoolsSorted = data.sort(function(a, b) {
  //     var aMixed = normalizeMixedDataValue(a)
  //     var bMixed = normalizeMixedDataValue(b)

  //     return aMixed < bMixed ? -1 : 1
  //   })

  //   let communitySchoolsList = []
  //   communitySchoolsSorted.forEach(res => {
  //     let communitySchoolsObj = {}
  //     communitySchoolsObj.value = 'communitySchools' + res
  //     communitySchoolsObj.title = 'Community School ' + res

  //     communitySchoolsList.push(communitySchoolsObj)
  //   })

  //   commit('addCommunitySchoolsList', communitySchoolsList)
  // },

  async get_councilDistrict({ commit }) {
    const engine = await qix_global()

    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['CityCouncilDistrict']
            },
            qNullSuppression: true
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    let overviewResults = []
    const overview = await engine.createSessionObject(overviewHyperCube)

    const layout = await overview.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      if (!Number.isNaN(parseInt(values[m][0].qText))) {
        const overviewData = {
          value: parseInt(!isNaN(values[m][0].qText))
            ? parseInt(values[m][0].qText)
            : 0,
          id: parseInt(values[m][0].qElemNumber, 0)
        }
        overviewResults.push(overviewData)
      }
    }

    const overviewResultsSorted = overviewResults.sort((a, b) =>
      parseFloat(a.value) > parseFloat(b.value) ? 1 : -1
    )

    let councilDistrictList = []
    overviewResultsSorted.forEach(res => {
      let councilDistrictObj = {}
      councilDistrictObj.value = 'councildistrict' + res.value
      councilDistrictObj.title = 'City Council District ' + res.value

      councilDistrictList.push(councilDistrictObj)
    })

    commit('addCouncilList', councilDistrictList)
  },

  async get_studyArea({ commit }) {
    const engine = await qix_global()
    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['CSPR Study Area']
            },
            qNullSuppression: true
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    let overviewResults = []
    const overview = await engine.createSessionObject(overviewHyperCube)

    const layout = await overview.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      if (!Number.isNaN(parseInt(values[m][0].qText))) {
        const overviewData = {
          value: parseInt(!isNaN(values[m][0].qText))
            ? parseInt(values[m][0].qText)
            : 0,
          id: parseInt(values[m][0].qElemNumber, 0)
        }
        overviewResults.push(overviewData)
      }
    }

    const overviewResultsSorted = overviewResults.sort((a, b) =>
      a.value > b.value ? 1 : -1
    )

    let studyAreaList = []
    overviewResultsSorted.forEach(res => {
      let studyAreaObj = {}
      studyAreaObj.value = 'studyarea' + res.value
      studyAreaObj.title = 'Study Area ' + res.value

      studyAreaList.push(studyAreaObj)
    })

    commit('addStudyAreaList', studyAreaList)
  },

  async get_sectors({ commit }) {
    const engine = await qix_global()

    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['Sector']
            },
            qNullSuppression: true
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    let overviewResults = []
    const overview = await engine.createSessionObject(overviewHyperCube)

    const layout = await overview.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      const overviewData = {
        value: values[m][0].qText,
        id: parseInt(values[m][0].qElemNumber, 0)
      }
      overviewResults.push(overviewData)
    }

    const overviewResultsSorted = overviewResults.sort((a, b) =>
      a.value > b.value ? 1 : -1
    )

    let sectorsList = []
    overviewResultsSorted.forEach(res => {
      let sectorObj = {}
      if (res.value === 'Alternative') {
        sectorObj.value = 'alteds'
        sectorObj.title = 'Alt-Ed Schools'
      } else {
        sectorObj.value = res.value.toLowerCase()
        sectorObj.title = res.value + ' Schools'
      }

      sectorsList.push(sectorObj)
    })
    commit('addSectorsList', sectorsList)
  },

  async get_networks({ commit }) {
    const engine = await qix_global()

    const overviewHyperCube = {
      qInfo: { qType: 'visualization' },
      qHyperCubeDef: {
        qDimensions: [
          {
            qDef: {
              qFieldDefs: ['Network']
            },
            qNullSuppression: true
          }
        ],
        qMeasures: [],
        qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
      }
    }

    let overviewResults = []
    const overview = await engine.createSessionObject(overviewHyperCube)

    const layout = await overview.getLayout()
    const values = layout.qHyperCube.qDataPages[0].qMatrix
    for (let m = 0; m < values.length; m++) {
      const overviewData = {
        value: values[m][0].qText,
        id: parseInt(values[m][0].qElemNumber, 0)
      }
      overviewResults.push(overviewData)
    }

    // const overviewResultsSorted = overviewResults.sort((a, b) => (a.value > b.value) ? 1 : -1)
    const overviewResultsSorted = overviewResults.sort(function(a, b) {
      // Normalize the file names with fixed-
      // width numeric data.
      var aMixed = normalizeMixedDataValue(a.value)
      var bMixed = normalizeMixedDataValue(b.value)

      return aMixed < bMixed ? -1 : 1
    })

    let networkList = []
    overviewResultsSorted.forEach(res => {
      let networkObj = {}
      if (res.value.toLowerCase().includes('network')) {
        networkObj.value = res.value.toLowerCase().replace(' ', '')
        networkObj.title = res.value
      } else {
        networkObj.value = res.value.toLowerCase()
        networkObj.title = res.value + ' Network'
      }

      networkList.push(networkObj)
    })
    commit('addNetworkList', networkList)
  },

  // async get_communitySchools({ commit }) {
  //   const engine = await qix_global()
  //   const overviewHyperCube = {
  //     qInfo: { qType: 'visualization' },
  //     qHyperCubeDef: {
  //       qDimensions: [
  //         {
  //           qDef: {
  //             qFieldDefs: ['IsCommunitySchool']
  //           },
  //           qNullSuppression: true
  //         }
  //       ],
  //       qMeasures: [],
  //       qInitialDataFetch: [{ qWidth: 10, qHeight: 500 }]
  //     }
  //   }

  //   let overviewResults = []
  //   const overview = await engine.createSessionObject(overviewHyperCube)

  //   const layout = await overview.getLayout()
  //   const values = layout.qHyperCube.qDataPages[0].qMatrix
  //   for (let m = 0; m < values.length; m++) {
  //     if (!Number.isNaN(parseInt(values[m][0].qText))) {
  //       const overviewData = {
  //         value:
  //           parseInt(values[m][0].qText) != NaN
  //             ? parseInt(values[m][0].qText)
  //             : 0,
  //         id: parseInt(values[m][0].qElemNumber, 0)
  //       }
  //       overviewResults.push(overviewData)
  //     }
  //   }

  //   const overviewResultsSorted = overviewResults.sort((a, b) =>
  //     a.value > b.value ? 1 : -1
  //   )

  //   let communitySchoolsList = []
  //   overviewResultsSorted.forEach(res => {
  //     let communitySchoolsObj = {}
  //     communitySchoolsObj.value = 'communitySchools' + res.value
  //     communitySchoolsObj.title = 'Community School ' + res.value
  //     communitySchoolsList.push(communitySchoolsObj)
  //   })

  //   commit('addCommunitySchoolsList', communitySchoolsList)
  // },

  clearFiltersSelected({ commit, dispatch }) {
    commit('clearFilters')
    dispatch('updateSchoolsResult')
  },

  filterSector({ commit, dispatch }, val) {
    commit('SET_SECTOR', val)
    dispatch('updateSchoolsResult')
  },

  filterNetwork({ commit, dispatch }, val) {
    commit('SET_NETWORK', val)
    dispatch('updateSchoolsResult')
  },

  filterCouncilDistrict({ commit, dispatch }, val) {
    commit('SET_COUNCIL_DISTRICT', val)
    dispatch('updateSchoolsResult')
  },

  filterAdmissionType({ commit, dispatch }, val) {
    commit('SET_ADMISSION_TYPE', val)
    dispatch('updateSchoolsResult')
  },

  filterSchoolLevel({ commit, dispatch }, val) {
    commit('SET_SCHOOL_LEVEL', val)
    dispatch('updateSchoolsResult')
  },

  filterCommunitySchools({ commit, dispatch }, val) {
    commit('SET_COMMUNITY_SCHOOLS', val)
    dispatch('updateSchoolsResult')
  },

  /**
   * This action updates the list of schools based on the currently selected filters.
   * These filters are set on the landing page when searching for a specific school.
   */
  async updateSchoolsResult({ commit, state }) {
    let sectors = state.filtersSector
    let networks = state.filtersNetwork
    let cityCouncilDistricts = state.filtersCityCouncilDistrict
    let admissionTypes = state.filtersAdmissionType
    let schoolLevels = state.filtersSchoolLevel
    let communitySchools = state.filtersCommunitySchools

    if (sectors.length == 0) {
      const unfilteredArray = state.list.map(a => a.sector)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      sectors = filteredArray
    }

    if (networks.length == 0) {
      const unfilteredArray = state.list.map(a => a.network)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      networks = filteredArray
    }

    if (cityCouncilDistricts.length == 0) {
      const unfilteredArray = state.list.map(a => a.councilDistrict)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      cityCouncilDistricts = filteredArray
    }

    if (admissionTypes.length == 0) {
      const unfilteredArray = state.list.map(a => a.admissionType)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      admissionTypes = filteredArray
    }

    if (schoolLevels.length == 0) {
      const unfilteredArray = state.list.map(a => a.schoolLevel)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      schoolLevels = filteredArray
    }

    if (communitySchools.length == 0) {
      const unfilteredArray = state.list.map(a => a.communitySchools)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      communitySchools = filteredArray
    }

    const searchSchools = await state.list.filter(
      obj =>
        sectors.includes(obj.sector) &&
        networks.includes(obj.network) &&
        cityCouncilDistricts.includes(obj.councilDistrict) &&
        admissionTypes.includes(obj.admissionType) &&
        schoolLevels.includes(obj.schoolLevel) &&
        communitySchools.includes(obj.communitySchools)
    )

    commit('setSearchList', searchSchools)
  },

  /**
   * This action produces a list similar to the "searchList" produced by setting filters,
   * but in this case filtered based upon a single value. Nothing is stored permanently,
   * so this action needs to be repeated anytime a filtered list is needed.
   * @param {*} type The type of school grouping from pageInfo.type - e.g., network
   * @param {*} name The value of the grouping from pageInfo.name - e.g., Network 1
   */
  async getSingleFilteredSchoolList({ state }, { type, name }) {
    const searchSchools = await state.list.filter(
      obj =>
        (type === 'sector' && name === obj.sector) ||
        (type === 'network' && name === obj.network) ||
        (type === 'councilDistrict' && name === obj.councilDistrict) ||
        (type === 'studyArea' && name === obj.studyArea) ||
        (type === 'citywide' && name === obj.citywide)
    )
    return searchSchools
  }
}
